// lookup codes
export const STATUS_REGISTERED = 'STATUS_REGISTERED'
export const STATUS_WITHDRAWN = "STATUS_WITHDRAWN"
export const STATUS_REJECTED = "STATUS_REJECTED"

export const SYS_PARAM_HTML = "SYS_PARAM_HTML"
export const SYS_PARAM_TEXT = "SYS_PARAM_TEXT"
export const SYS_PARAM_NUMBER = "SYS_PARAM_NUMBER"

// lookup code types
export const QUALIFICATION = "QUALIFICATION"
export const REGION = "REGION"
export const GENDER = "GENDER"
export const SKILL = "SKILL"

// roles
export const ROLE_ADMIN = "Admin"
export const ROLE_CANDIDATE = "Candidate"
export const ROLE_GOVERNMENT = "Government"

// menu
export const MAINTAIN_LOOKUP_CODES = 'Maintain Lookup Codes'
export const MAINTAIN_SYSTEM_PARAMETERS = 'Maintain System Parameters'

// system parameters
export const FAQ_URL = "FAQ_URL"
export const HOME_PAGE_TEXT = "HOME_PAGE_TEXT"
export const LIST_OF_CANDIDATES_TEXT = "LIST_OF_CANDIDATES_TEXT"
export const INTRO_TEXT_CANDIDATE_DETAILS = "INTRO_TEXT_CANDIDATE_DETAILS"
export const STATE_GOVT_EMPLOYEE_LINK = "STATE_GOVT_EMPLOYEE_LINK"
export const QUALIFICATIONS_HELPTEXT = "QUALIFICATIONS_HELPTEXT"
export const SKILLS_EXPERTISE_HELPTEXT = "SKILLS_EXPERTISE_HELPTEXT"
export const CONTACT_US_PAGE_HTMLTEXT="CONTACT_US_PAGE_HTMLTEXT"
export const DECLARATION_BODY_TEXT="DECLARATION_BODY_TEXT"
export const FAQ_FOR_GENERAL_USERS="FAQ_FOR_GENERAL_USERS"
export const FAQ_FOR_AUTHORISED_USERS="FAQ_FOR_AUTHORISED_USERS"
export const TITLE_HELPTEXT="TITLE_HELPTEXT"
export const LINKEDIN_LINK_HELPTEXT="LINKEDIN_LINK_HELPTEXT"
export const ANY_COMMENTS_HELPTEXT="ANY_COMMENTS_HELPTEXT"
export const COMMUNICATIONS_HELPTEXT='COMMUNICATIONS_HELPTEXT'
export const GOOGLE_ANALYTICS_TRACKING_CODE='GOOGLE_ANALYTICS_TRACKING_CODE'



// WEBPACK FOOTER //
// ./src/js/const.js